import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fx-currency-limits',
      params,
      options
    )
  },
  save (data) {
    return apiClient.sendRequest(
      'PUT',
      'api/admin/v1/fx-currency-limits',
      data
    )
  }
}
